import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase-config'
import Seo from '../components/Seo';

function QRLander() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchQrSettings = async () => {
      try {
        const docRef = doc(db, 'settings', 'qrLandingPage')
        const docSnap = await getDoc(docRef)
        
        if (docSnap.exists()) {
          const settings = docSnap.data()
          
          // Handle redirect based on landingPageType
          switch (settings.landingPageType) {
            case 'home':
              navigate('/', { replace: true })
              break
            case 'custom':
              if (settings.customUrl) {
                // External URL - redirect using window.location
                window.location.href = settings.customUrl
              } else {
                // Fallback to home if no custom URL is set
                navigate('/', { replace: true })
              }
              break
            case 'offer':
              // TODO: Navigate to offer page when implemented
              // For now, redirect to home
              navigate('/', { replace: true })
              break
            default:
              // Default to home page
              navigate('/', { replace: true })
          }
        } else {
          // No settings found, default to home page
          console.warn('No QR landing page settings found, redirecting to home')
          navigate('/', { replace: true })
        }
      } catch (err) {
        console.error('Error fetching QR settings:', err)
        setError('Failed to load redirect settings')
        // Fallback to home page after 2 seconds
        setTimeout(() => {
          navigate('/', { replace: true })
        }, 2000)
      } finally {
        setLoading(false)
      }
    }

    fetchQrSettings()
  }, [navigate])

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Seo title="Alex Albert Personal Training" noindex />
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Error</h1>
          <p className="text-gray-700 mb-4">{error}</p>
          <p className="text-sm text-gray-500">Redirecting to home page...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600 mb-4"></div>
        <p className="text-gray-700">Redirecting...</p>
      </div>
    </div>
  )
}

export default QRLander
